export enum Action {
    Evaluate = 1,
    StartStandardVoucher = 2,
    StartKpdPair = 3,
    StartInternalDirect = 4,
    PotentialDonors = 5,
    WithdrawDonor = 6
}